import { DATE_SET_UPDATETIME, DATE_SET_TODAY, DATE_SET_YESTERDAY, DATE_SET_TOMORROW, DATE_SET_TENDAYSAGO, DATE_SET_TWENTYDAYSAGO, DATE_CLEAN_ALL_DATES } from '../types'
import Moment from 'moment'

const state = {
  today: {
    day: null,
    month: null,
    year: null,
    hour: null,
    minute: null,
    second: null
  },
  yesterday: {
    day: null,
    month: null,
    year: null
  },
  tomorrow: {
    day: null,
    month: null,
    year: null
  },
  tenDaysAgo: {
    day: null,
    month: null,
    year: null
  },
  twentyDaysAgo: {
    day: null,
    month: null,
    year: null
  },
  updateTime: {
    date: null,
    phrase: 'atualizado',
    time: 'agora'
  }
}

const mutations = {
  [DATE_SET_TODAY] (state, date) {
    state.today = date
  },
  [DATE_SET_YESTERDAY] (state, date) {
    state.yesterday = date
  },
  [DATE_SET_TOMORROW] (state, date) {
    state.tomorrow = date
  },
  [DATE_SET_TENDAYSAGO] (state, date) {
    state.tenDaysAgo = date
  },
  [DATE_SET_TWENTYDAYSAGO] (state, date) {
    state.twentyDaysAgo = date
  },
  [DATE_SET_UPDATETIME] (state, date) {
    state.updateTime = date
  },
  [DATE_CLEAN_ALL_DATES] (state) {
    state.today = null
    state.yesterday = null
    state.tomorrow = null
    state.tenDaysAgo = null
    state.twentyDaysAgo = null
  }
}

const getters = {
  getTodayDate: state => {
    return state.today
  },
  getYesterdayDate: state => {
    return state.yesterday
  },
  getTomorrowDate: state => {
    return state.tomorrow
  },
  getTenDaysAgo: state => {
    return state.tenDaysAgo
  },
  getTwentyDaysAgo: state => {
    return state.twentyDaysAgo
  },
  getUpdateTime: state => {
    return state.updateTime
  }
}

const actions = {
  updateToday: function ({ commit, state }) {
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()
    var h = today.getHours()
    var m = today.getMinutes()
    var s = today.getSeconds()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    commit(DATE_SET_TODAY, {
      day: dd,
      month: mm,
      year: yyyy,
      hour: h,
      minute: m,
      second: s
    })
  },
  updateTenDaysAgo: function ({ commit, state }) {
    var today = new Date()
    today.setDate(today.getDate() - 10)
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    commit(DATE_SET_TENDAYSAGO, { day: dd, month: mm, year: yyyy })
  },
  updateYesterday: function ({ commit, state }) {
    var today = new Date()
    today.setDate(today.getDate() - 1)
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    commit(DATE_SET_YESTERDAY, { day: dd, month: mm, year: yyyy })
  },
  updateTomorrow: function ({ commit, state }) {
    var today = new Date()
    today.setDate(today.getDate() + 1)
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    commit(DATE_SET_TOMORROW, { day: dd, month: mm, year: yyyy })
  },
  updateTwentyDaysAgo: function ({ commit, state }) {
    var today = new Date()
    today.setDate(today.getDate() - 20)
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    commit(DATE_SET_TWENTYDAYSAGO, { day: dd, month: mm, year: yyyy })
  },
  updateUpdateTime: function ({ commit, state }) {
    let date = new Date()
    commit(DATE_SET_UPDATETIME, {...state.updateTime, ...{date}})
  },
  updateUpdateTimeText: function ({ commit, state }) {
    let updatedText = {}
    let lastUpdatedDate = state.updateTime.date || new Date()

    let minutes = Moment(new Date()).diff(lastUpdatedDate, 'minutes')

    if (minutes === 0) {
      updatedText = { phrase: 'atualizado', time: 'agora' }
    } else {
      updatedText = { phrase: 'atualizado há', time: minutes + ' min' }
    }
    commit(DATE_SET_UPDATETIME, {...state.updateTime, ...updatedText})
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
